// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Kit } from './kit';
import { Program } from './program';
import { ProgramKitTagMap } from './program-kit-tag-map';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProgramKit extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get tags(): string {
    const list = this.tagList;
    return list.length == 0 ? '' : list.join(', ');
  }

  get tagList(): string[] {
    return this.programKitTagMaps.map(p => p.kitTag.name);
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Boolean */
  includeInAllowance!: boolean;
  /** Guid FK kit */
  kitId!: string;
  /** Guid FK program */
  programId!: string;
  /** Binary */
  rowVersion!: any;
  /** FK kitId */
  kit!: Kit;
  /** FK programId */
  program!: Program;
  /** Inv FK programKitId */
  programKitTagMaps!: ProgramKitTagMap[];
}

